import React from 'react';
import HomeMain from '../components/HomePage/HomeMain/HomeMain';


interface Props {
  
}

const HomePage: React.FC<Props> = (props) => {
  return <HomeMain />;
};

export default HomePage;